import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AccreditationModelModel } from "src/app/Model/AccreditationModel.model";
import { AgencyPolicyModel } from "src/app/Model/AgencyPolicy.model";
import { AreaMessageRequestView } from "src/app/Model/AreaMessageRequestView.model";
import { ResponseData } from "src/app/Model/Base/Response";
import { BillingPeriodModel } from "src/app/Model/BillingPeriod.model";
import { DocumentLegalModel } from "src/app/Model/DocumentLegalModel.Model";
import { ExtraWarrantyModel } from "src/app/Model/ExtraWarranty.model";
import { RequestLegalDocuments } from "src/app/Model/RequestLegalDocuments.model";
import { RequestStatusAgencyExtraWarrantyView } from "src/app/Model/RequestStatusAgencyExtraWarrantyView.model";
import { RequestStatusAgencyPolicyViewModel } from "src/app/Model/RequestStatusAgencyPolicyView.model";
import { RequestStatusBillingViewModel } from "src/app/Model/RequestStatusBillingView.model";
import { RequestStatusDocumentModel } from "src/app/Model/RequestStatusDocument.model";
import { RequestStatusExtraWarrantyView } from "src/app/Model/RequestStatusExtraWarrantyView.model";
import { RequestStatusLegalView } from "src/app/Model/RequestStatusLegalView";
import { RequestStatusProcess } from "src/app/Model/RequestStatusProcess";
import { RequestStatusRiskStatusView } from "src/app/Model/RequestStatusRiskStatusView.model";
import { RequestStatusWarrantyUpdateView } from "src/app/Model/RequestStatusWarrantyUpdateView.model";
import { SendMessageOnlyModel } from "src/app/Model/SendMessageOnlye.model";
import { StatusChangeByComponentView } from "src/app/Model/StatusChangeByComponentView.model";
import { WarrantyTypeModel } from "src/app/Model/WarrantyType.model";
import { VInspektorModel } from "../../Model/VInspektor.model";
import { BaseService } from "../Base/BaseService";
import { SessionStorageService } from "../sessionStorageService/session-storage.service";
import { AuthService } from "../Interceptor/auth.service";

@Injectable({
  providedIn: "root",
})
export class RequesStatusService extends BaseService {
  constructor(public http: HttpClient, public lsService : SessionStorageService, authService: AuthService) { 
    super(http, lsService,authService);
  }

  public async SetStatus(data: RequestStatusProcess) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "Post").then((res) => {
      Status = res
    });
    return Status;
  }
  public async SetStatusByComponent(data: StatusChangeByComponentView) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "StatusChangeByComponent").then((res) => {
      Status = res
    });
    return Status;
  }
  public async SetAgencyTermsModify(data: StatusChangeByComponentView) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "PostAgencyTermsModify").then((res) => {
      Status = res
    });
    return Status;
  }
  public async SetStatusBilling(data: RequestStatusBillingViewModel) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "PostBilling").then((res) => {
      Status = res
    });
    return Status;
  }
  public async SetStatusRiskStatus(data: RequestStatusRiskStatusView) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "PostRiskStatus").then((res) => {
      Status = res
    });
    return Status;
  }

  public async SetAprobationDocuments(data: RequestStatusLegalView) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "PostAprobationDocuments").then((res) => {
      Status = res
    });
    return Status;
  }

  public async SetStatuslegal(data: RequestStatusLegalView) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "PostLegalStatus").then((res) => {
      Status = res
    });
    return Status;
  }

  public async PostSignedDocsStatus(data: StatusChangeByComponentView){
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "PostSignedDocsStatus").then((res) => {
      Status = res
    });
    return Status;
  }

  public async PostLegalStatusDocuments(data: RequestStatusLegalView) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "PostLegalStatusDocuments").then((res) => {
      Status = res
    });
    return Status;
  }

  public async SetStatuslegalDocuments(data: RequestStatusLegalView) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "PostLegalDocuments").then((res) => {
      Status = res
    });
    return Status;
  }
  public async SetSalesDocuments(data: RequestStatusLegalView) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "PostSalesDocuments").then((res) => {
      Status = res
    });
    return Status;
  }

  public async SetStatusExtraWarranty(data: RequestStatusExtraWarrantyView) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "PostExtraWarranty").then((res) => {
      Status = res
    });
    return Status;
  }
  public async SetStatusWarrantyUpdate(data: RequestStatusWarrantyUpdateView) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "PostWarrantyUpdate").then((res) => {
      Status = res
    });
    return Status;
  }

  public async SetStatusAgencyPolicy(data: RequestStatusAgencyPolicyViewModel) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "PostAgencyPolicy").then((res) => {
      Status = res
    });
    return Status;
  }
  public async SetStatusAgencyExtraWarranty(data: RequestStatusAgencyExtraWarrantyView) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "PostAgencyExtraWarranty").then((res) => {
      Status = res
    });
    return Status;
  }
  public async SetStatusExtraWarrantyReview(data: StatusChangeByComponentView) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "PostAgencyExtraWarrantyReview").then((res) => {
      Status = res
    });
    return Status;
  }
  public async SendMessage(data: RequestStatusProcess) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "SendMessage").then((res) => {
      Status = res
    });
    return Status;
  }
  public async SendMessageOnly(data:SendMessageOnlyModel) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "SendMessageOnly").then((res) => {
      Status = res
    });
    return Status;
  }
  public async SendMessageOnlyLegal(data:SendMessageOnlyModel) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "SendMessageOnlyLegal").then((res) => {
      Status = res
    });
    return Status;
  }
  public async SendMessageStatus(data:SendMessageOnlyModel) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "SendMessageStatus").then((res) => {
      Status = res
    });
    return Status;
  }
  public async SendMessageDoc(data: RequestStatusDocumentModel) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "SendMessageDoc").then((res) => {
      Status = res
    });
    return Status;
  }



  public async PostDoc(data: RequestStatusDocumentModel) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "PostDoc").then((res) => {
      Status = res
    });
    return Status;
  }


  public async PostSignatures(data: RequestStatusDocumentModel) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "PostSignatures").then((res) => {
      Status = res
    });
    return Status;
  }
  public async getBillingPeriods() {
    let periods: BillingPeriodModel[];
    await this.PostData("", "RequestStatus", "GetBillingPeriods").then((res) => {
      if (res.head.status) {
        periods = JSON.parse(res.body.response);
      }
    });
    return periods;
  }
  public async getAccreditationModels() {
    let periods: AccreditationModelModel[];
    await this.PostData("", "RequestStatus", "GetAccreditationModels").then((res) => {
      if (res.head.status) {
        periods = JSON.parse(res.body.response);
      }
    });
    return periods;
  }
  public async getWarrantyTypes() {
    let periods: WarrantyTypeModel[];
    await this.PostData("", "RequestStatus", "GetWarrantyTypes").then((res) => {
      if (res.head.status) {
        periods = JSON.parse(res.body.response);
      }
    });
    return periods;
  }
  public async getAgencyPolicy(idRequest) {
    let periods: AgencyPolicyModel;
    await this.PostData(idRequest, "RequestStatus", "GetAgencyPolicy").then((res) => {
      if (res.head.status) {
        periods = JSON.parse(res.body.response);
      }
    });
    return periods;
  }

  public async GetLegalDocumentsByRequest(idRequest) {
    let response: RequestLegalDocuments;
    await this.PostData(idRequest, "RequestStatus", "GetLegalDocumentsByRequest").then((res) => {
      if (res.head.status) {
        response = JSON.parse(res.body.response);
      }
    });
    return response;
  }

  public async getExtraWarranty(idRequest) {
    let periods: ExtraWarrantyModel;
    await this.PostData(idRequest, "RequestStatus", "GetExtraWarranty").then((res) => {
      if (res.head.status) {
        periods = JSON.parse(res.body.response);
      }
    });
    return periods;
  }
  public async getAprovedFlowState(data){
    let Document: boolean;
    await this.PostData(data,"RequestStatus","GetAprovedFlowState").then((res) => {
      if(res.head.status != 'False') {
        Document = JSON.parse(res.body.response);
      }
    });
    return Document;
  }
  public async getMessageArea(data:AreaMessageRequestView){
    let Document: string;
    await this.PostData(data,"RequestStatus","GetMessageArea").then((res) => {
      if(res.head.status != 'False') {
        Document = JSON.parse(res.body.response);
      }
    });
    return Document;
  }

  public async getDocumentFlowState(data){
    let Document: boolean;
    await this.PostData(data,"RequestStatus","GetDocumentFlowState").then((res) => {
      if(res.head.status != 'False') {
        Document = JSON.parse(res.body.response);
      }
    });
    return Document;
  }


  public async getConnectFlowState(data){
    let Document: boolean;
    await this.PostData(data,"RequestStatus","GetConnectFlowState").then((res) => {
      if(res.head.status != 'False') {
        Document = JSON.parse(res.body.response);
      }
    });
    return Document;
  }

  public async getStateConection(data){
    let State: number;
    await this.PostData(data, "RequestStatus","GetStateConection").then((res) => {
      if(res.head.status != 'false') {
        State = JSON.parse(res.body.response)
      }
    });
    return State;
  }

  public async checkIfRequestIsRejected(data){
    let reject: boolean;
    await this.PostData(data,"RequestStatus","CheckIfRequestIsRejected").then((res) => {
      if(res.head.status != 'False') {
        reject = JSON.parse(res.body.response);
      }
    })
    return reject;
  }

  public async getAgencyDocumentLegal(data){
    let Document: DocumentLegalModel;
    await this.PostData(data,"RequestStatus","GetAgencyDocumentLegal").then((res) => {
      if(res.head.status != 'False') {
        Document = JSON.parse(res.body.response);
      }
    });
    return Document;
  }

  public async SetStatusAgencyDocumentLegal(data: StatusChangeByComponentView) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "PostAgencyDocumentLegal").then((res) => {
      Status = res
    });
    return Status;
  }

  public async PostAgencyUploadLegalDocuments(data: RequestStatusLegalView) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "PostAgencyUploadLegalDocuments").then((res) => {
      Status = res
    });
    return Status;
  }

  public async PutAgencyDocumentLegal(data: RequestStatusLegalView) {
    let Status: ResponseData;
    await this.PostData(data, "RequestStatus", "PutAgencyDocumentLegal").then((res) => {
      Status = res
    });
    return Status;
  }

  public async GetStatusRequest(data) {
    let Status: string;
    await this.PostData(data, "RequestStatus", "GetStatusRequest").then((res) => {
      Status = JSON.parse(res.body.response)
    });
    return Status;
  }
  public async GetInspektorStatus(idRequest:number) {
    let Status: VInspektorModel[];
    await this.PostData(idRequest, "RequestStatus", "GetInspektorStatus").then((res) => {
      Status = JSON.parse(res.body.response)
    });
    return Status;
  }
}
